/// <amd-module name="Repos/Tfvc/Views/ChangesetDetails/ChangesetDetailsViewService" />
import { IArtifactDiscussionThreadService } from "Repos/Artifact/Discussion/ArtifactDiscussionThreadService";
import { TfvcVersionType } from "Repos/Common/Contracts/Git";
import { getTfvcRoutingService } from "Repos/Tfvc/Common/TfvcRoutingService";
import { getShortChangeComment } from "Repos/Tfvc/Common/Utils/Comment";
import { ChangeDetailsViewService, IChangeDetailsViewService } from "Repos/Tfvc/Views/ChangeDetails/ChangeDetailsViewService";
import * as Resources from "Repos/Tfvc/Views/ChangesetDetails/Resources";
import { format } from "VSS/Core/Util/String";
import { IVssPageContext, Services } from "VSS/Platform/Context";
import { IdentityRef } from "VSS/Platform/Contracts/WebApi";
import { IHeaderCommandBarItem } from "VSSUI/HeaderCommandBar";
import { getDiscussionThreadService } from "./ChangesetDiscussionThreadService";
import { IChangesetDetailsData } from "./Contracts";

export interface IChangesetDetailsViewService extends IChangeDetailsViewService {
    getChangesetId(): number;
}

class ChangesetDetailsViewService extends ChangeDetailsViewService implements IChangesetDetailsViewService {
    private changesetId: number;

    public getChangesetId(): number {
        return this.changesetId;
    }

    public getDocumentTitle() {
        return format(Resources.DocumentTitleFormat, this.changesetId, this.shortComment);
    }

    public getHeaderMenuItems(smallScreen: boolean): IHeaderCommandBarItem[] {
        const browseFilesUrl = getTfvcRoutingService(this.pageContext).getFilesHubUrl(undefined, this.getChangeId());

        return [
            {
                id: "browse-files",
                groupKey: "default-actions",
                text: Resources.BrowseFiles,
                href: browseFilesUrl,
                important: !smallScreen
            }
        ];
    }

    protected getChangeName(): string {
        return Resources.Changeset;
    }

    protected getDiscussionService(): IArtifactDiscussionThreadService {
        return getDiscussionThreadService(this.pageContext);
    }

    public getVersionType(): TfvcVersionType {
        return TfvcVersionType.Changeset;
    }

    protected initializeFields(changesetData: IChangesetDetailsData): void {
        const { changesetId, comment, creationDate, owner, ownerDisplayName, ownerId, ownerRef } = changesetData;
        this.changesetId = changesetId;
        this.id = changesetId.toString();
        this.defaultText = format(Resources.DefaultChangesetComment, this.id);
        this.owner = ownerRef || ({ id: ownerId, uniqueName: owner, displayName: ownerDisplayName } as IdentityRef);
        this.checkinDate = creationDate;
        this.fullComment = comment || this.getDefaultChangeText();
        this.shortComment = getShortChangeComment(this.fullComment);
    }
}

const serviceName = "IChangesetDetailsViewService";
export function getChangesetViewService(pageContext: IVssPageContext): IChangesetDetailsViewService {
    return pageContext.getService(serviceName);
}

Services.add(serviceName, { serviceFactory: ChangesetDetailsViewService });
